import { render, staticRenderFns } from "./SetKid.vue?vue&type=template&id=18ee18ce&scoped=true"
import script from "./SetKid.vue?vue&type=script&lang=js"
export * from "./SetKid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18ee18ce",
  null
  
)

export default component.exports